export default "__VITE_ASSET__CaS07B0G__"